import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertSettingsComponent } from './alert-settings.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [
    AlertSettingsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    AlertSettingsComponent
  ],
})

export class AlertSettingsModule { }